import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
import EIDsContent from '../components/EIDs/EIDsContent'

const EIDs = () => {
  useEffect(() => {
    document.title = "EIDs | GoPaperless"
},[])

  return (
    <>
    <NavbarTop/>
    <EIDsContent/>
    
    </>
    
  )
}

export default EIDs